export default "__VITE_ASSET__FLtGe48a__"